module.exports = "/packs/media/images/InvestmentMix-78921ba484a625ddd6002ea366e218b9.png";